
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-03-22 (1.0.0) (jhoward)
 *    - Copy from Bimini_aperitif.vue component to Bimini_default.vue component.
 *
 *  2023-04-17 (1.0.1) (jhoward)
 *    - Remove unused methods from Bimini_default.vue component.
 *
 *  2023-06-19 (1.1.0) (jhoward)
 *    - Support section.ms_show_pricing_header in <Bimini_defaultSection>.
 *
 *  2023-08-23 (1.2.0) (jhoward)
 *    - Use <menu-version> in <Bimini_defaultSection>.
 *    - Place containerClasses() in computed rather than methods in <Bimini_defaultSection>.
 *
 *  2024-12-16 (1.2.1) (jhoward)
 *    - Tweak layout for highlighted box menu items in <Bimini_defaultSection>.
 *
 *  2025-02-11 (1.3.0) (jhoward)
 *    - Add <menu-schedules> to the <Bimini_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <bimini-default-section>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MENU_ITEM_TAG_LOCATIONS, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "Bimini_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
    menuItemTagLocation: {
      type: String as PropType<MENU_ITEM_TAG_LOCATIONS>,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    isTitleBufferVisible: {
      type: Boolean,
      default: false
    },
  },
})
